<template>
    <div>
        <div class="modal" tabindex="-1" id="updateplan">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title modal-top">Update/change property plan type</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="amount">Current plan</label>
                        <input disabled v-model="planData.plan_type" type="text" class="form-control" id="currentplan" placeholder="Current Plan">
                    </div>
                    <div class="form-group">
                        <label for="destination">Plan</label>
                        <select class="form-control" id="destination" v-model="plan">
                            <option selected disabled value="">Select plan</option>
                            <option :disabled="item.name == planData.plan_type" v-for="(item, index) in plans" :key="index" :value="item.id">{{item.name}}</option>
                        </select>
                    </div>
                    <div class="form-group" v-if="filteredPlan != ''">
                        <label for="amount">Plan percentage %</label>
                        <input disabled v-model="filteredPlan[0].percentage" type="text" class="form-control" id="percentage" placeholder="Percentage">
                    </div>
                </div>
                
                <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                    <button :disabled="updating" type="button" class="btn sheltaPrimaryBtn" @click="changePlan()">Change plan
                        <span v-if="updating"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                    </button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import '@/assets/styles/custom.scss';
import { Service } from "../store/service";
import moment from "moment";
import Vue from "vue";
import $ from "jquery";
const Api = new Service();
export default {
    name: "UpdatePlanModal",
    props: {
        planData: {}
    },
    data() {
        return {
            updating: false,
            currentPlan: "",
            plan: "",
            batch: "",
            plans: "",
            filteredPlan: "",
        }
    },
    watch: {
        plan(newVal) {
        if (newVal) {
            this.filteredPlan = this.plans.filter(plan => plan.id == newVal);
            console.log("Filtered plan", this.filteredPlan)
        }
      },
    },
    mounted() {
        this.landlordplans();
        this.batch = this.planData.batch;
    },
    methods: {
        async landlordplans() {
            this.loadingplans = true;
            await Api.getRequest(`fetch-landlord-plans`)
            .then(data => {
               this.loadingplans = false;
                // console.log("plans", data);
                if(data.data.success) {
                    this.plans = data.data.plans;
                }
                if (data.data.error) {
                    this.$store.commit("setApiFailed", data.data.error);
                    // this.$toast.error(data.data.error);
                }
            }).catch((err) => {
                this.loadingplans = false;
                console.log(err);
                this.$store.commit("setApiFailed", err);
                // this.$toast.error(err);
            });
        },
        async changePlan() {
            if (this.batch == '' || this.plan == '') {
               return this.$store.commit("setApiFailed", "Fill all required fields");
           }
           this.updating = true;
           try {
               await Api.postRequest(`update-property-plan`, {
                batch: this.batch,
                plan_id: this.plan,
               })
               .then(res => {
                   this.updating = false;
                //    console.log("Plan Update", res);
                   if (res.data.success) {
                       this.$store.commit("setApiSuccess", "Success");
                       $("#updateplan")
                        .removeClass("fade")
                        .modal("hide");
                        this.$emit('callFunction');
                        // location.reload();
                        // this.$router.reload()
                   }
                   if (res.data.error){
                       this.$store.commit("setApiFailed", res.data.error);
                   }
   
                   // this.$store.commit("setApiSuccess", "Success");
               })
               .catch(err => {
                   this.updating = false;
                   // console.log(err);
                   this.$store.commit("setApiFailed", "An error occured");
               });
           } finally {
               // console.log("Closed connection");
           }
        }
    },
    filters: {
        moment: function(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        },
        moment2: function(date) {
            return moment(date).format("MMMM Do YYYY");
        },
        moment3: function(date) {
            return moment(date).format("h:mm:ss a");
        },
    }
}
</script>


<style scoped lang="scss">
.withdrawal-header {
    // margin-top: 10px;
    font-family: Lato;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: #1F2937;

}

.modal-header  {
    border-bottom: none;
}
.modal-footer {
    border-top: none;
}

.sheltaPrimaryBtn {
    background: #0033EA;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
    outline: 0;
    box-shadow: none;
}

#currentplan {
    background: transparent !important;
}
.modal-top {
    font-family: Lato;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    color: #1F2937;

}

.form-group {
    label {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        color: #777777;
        text-align: left;
        display: flex;
    }
    input, select {
        border: 1px solid #BBBBBB;
        // color: #D1DBFF1A;
        height: 45px;
        color: #333333;
        font-family: Lato;
        font-weight: 600;
        font-size: 12px;
        box-shadow: none;
        outline: 0;
    }
}

</style>